import lightOrange from 'src/style/themes/lightOrange';
import lightBlue from 'src/style/themes/lightBlue';
import darkOrange from 'src/style/themes/darkOrange';
export const THEME_LS_KEY = 'ca_theme';
export const themes = {
    lightOrange,
    lightBlue,
    darkOrange
};
